import React, { useState, useEffect, useCallback, useRef } from "react";
import { NavLink, Outlet, useLocation, useMatch } from "react-router-dom";
import {
  getFirestore,
  collection,
  getDocs,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import ArrowRightIcon from "@untitled-ui/icons-react/build/esm/ArrowRight";
import Edit02Icon from "@untitled-ui/icons-react/build/esm/Edit02";
import XIcon from "@untitled-ui/icons-react/build/esm/X";
import {
  Box,
  Button,
  Card,
  Container,
  Stack,
  SvgIcon,
  Typography,
  Tabs,
  DialogContent,
  Dialog,
  OutlinedInput,
  InputAdornment,
  TextField,
  Checkbox,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Avatar,
  Link,
  Chip,
  Alert,
  AlertTitle,
} from "@mui/material";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { Scrollbar } from "../../components/scrollbar";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";

import Download01Icon from "@untitled-ui/icons-react/build/esm/Download01";
import PlusIcon from "@untitled-ui/icons-react/build/esm/Plus";
import Upload01Icon from "@untitled-ui/icons-react/build/esm/Upload01";
import SearchMdIcon from "@untitled-ui/icons-react/build/esm/SearchMd";
import { FileDropzone } from "../../components/file-dropzone";
import { SeverityPill } from "../../components/severity-pill";
import { format, addDays } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";

export function Vinculos() {
  const [currentTab, setCurrentTab] = useState("all");
  const [filters, setFilters] = useState({});
  const [entidades, setEntidades] = useState([]);
  const [openFileUploader, setOpenFileUploader] = useState(false);

  const [open, setOnOpen] = useState(false);
  const [files, setFiles] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    setFiles([]);
  }, [open]);

  const sortOptions = [
    {
      label: "Legislatura (2021) - (2024)",
      value: "razaosocial",
    },
  ];

  useEffect(() => {
    const db = getFirestore();
    const auth = getAuth();

    const ordersRef = collection(db, "users", "belacruz@eleg", "sessoes");
    const queryRef = query(ordersRef, where("statusSessao", "!=", "fechada"));

    onSnapshot(queryRef, (querySnapshot) => {
      const parsedData = querySnapshot.docs.map((doc) => {
        const data = doc.data();
        // Cria um objeto com as propriedades e seus respectivos valores
        const obj = {
          id: doc.id,
          dataSessao: data.dataSessao,
          sessao: data.sessao,
          statusSessao: data.statusSessao,
          legislatura: data.legislatura,
          cnpj: data.cnpj,

          // Adicione outras propriedades e seus valores aqui, se necessário
        };
        return obj;
      });

      // Ordenar os dados com base na propriedade 'dataSessao'
      parsedData.sort((a, b) => {
        // Converta as datas para objetos Date para que a ordenação funcione corretamente
        const dateA = new Date(a.dataSessao);
        const dateB = new Date(b.dataSessao);

        //@ts-ignore
        return dateB - dateA;
      });

      //@ts-ignore
      setEntidades(parsedData);
    });
  }, []);

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 3,
      }}
    >
      <Container maxWidth="xl">
        <Stack spacing={4}>
          <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Stack spacing={1}>
              <Typography variant="h4">Sessões em Pauta</Typography>
            </Stack>
          </Stack>

          <Alert severity="success">
            <AlertTitle>Sessões em Ordem Cronológica</AlertTitle>
            Descubra as sessões da nossa legislatura organizadas
            cronologicamente. Acompanhe o histórico de reuniões, deliberações e
            discussões dos vereadores.
          </Alert>

          <Card>
            <Stack
              alignItems="center"
              direction="row"
              flexWrap="wrap"
              spacing={3}
              sx={{ p: 3 }}
            >
              <Box component="form" sx={{ flexGrow: 1 }}>
                <OutlinedInput
                  defaultValue=""
                  fullWidth
                  placeholder="Procure pela sessões..."
                  startAdornment={
                    <InputAdornment position="start">
                      <SvgIcon>
                        <SearchMdIcon />
                      </SvgIcon>
                    </InputAdornment>
                  }
                />
              </Box>
              <TextField
                label="Legislatura"
                name="sort"
                select
                SelectProps={{ native: true }}
              >
                {sortOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </TextField>
            </Stack>

            <Box sx={{ position: "relative" }}>
              <Scrollbar>
                <Table sx={{ minWidth: 700 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox checked={false} />
                      </TableCell>
                      <TableCell>Sessão</TableCell>
                      <TableCell>Legislatura</TableCell>
                      <TableCell>Data</TableCell>
                      <TableCell align="left">Status</TableCell>
                      <TableCell align="right">Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {entidades !== undefined &&
                      entidades.map((item) => {
                        //@ts-ignore
                        const statusColor =
                          //@ts-ignore
                          (item.statusSessao === "rascunho" && "warning") ||
                          //@ts-ignore
                          (item.statusSessao == "aberta" && "success") ||
                          //@ts-ignore
                          (item.statusSessao == "fechada" && "error") ||
                          //@ts-ignore
                          (item.statusSessao && false);
                        //@ts-ignore
                        const legislaturaSessao =
                          //@ts-ignore
                          (item.legislatura === "2025-2028" &&
                            "Legislatura (2025) - (2028)") ||
                          //@ts-ignore
                          (item.legislatura === "2024" &&
                            "Legislatura (2021) - (2024)") ||
                          //@ts-ignore
                          (item.legislatura == "" && "Não informado");
                        const dataSessao = format(
                          //@ts-ignore
                          addDays(new Date(item.dataSessao), 1),
                          "dd 'de' MMM",
                          { locale: ptBR }
                        );
                        const valueSessao =
                          //@ts-ignore
                          item.sessao === "" ? "Não informado" : item.sessao;

                        return (
                          <TableRow
                            hover
                            //@ts-ignore
                            key={item.id}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox checked={false} />
                            </TableCell>
                            <TableCell>
                              {
                                //@ts-ignore
                                item.sessao === "" ? (
                                  <Chip label={valueSessao} size="small" />
                                ) : (
                                  //@ts-ignore
                                  valueSessao
                                )
                              }
                            </TableCell>
                            <TableCell>
                              {
                                //@ts-ignore
                                item.legislatura === "" ? (
                                  <Chip
                                    label={legislaturaSessao}
                                    size="small"
                                  />
                                ) : (
                                  legislaturaSessao
                                )
                              }
                            </TableCell>
                            <TableCell>
                              {/*@ts-ignore*/}
                              {dataSessao}
                            </TableCell>
                            <TableCell>
                              <SeverityPill color={statusColor}>
                                {/*@ts-ignore*/}
                                {item.statusSessao}
                              </SeverityPill>
                            </TableCell>
                            <TableCell align="right">
                              <IconButton
                                style={{
                                  opacity:
                                    //@ts-ignore
                                    item.statusSessao === "rascunho" ||
                                    //@ts-ignore
                                    item.statusSessao == "fechada"
                                      ? 0.25
                                      : 1,
                                }}
                                disabled={
                                  //@ts-ignore
                                  item.statusSessao === "rascunho" ||
                                  //@ts-ignore
                                  item.statusSessao == "fechada"
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  navigate(
                                    //@ts-ignore
                                    `/plenario-digital/sessoes/${item.id}/edit`
                                  );
                                }}
                              >
                                <SvgIcon>
                                  <ArrowRightIcon />
                                </SvgIcon>
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </Scrollbar>
            </Box>
          </Card>
        </Stack>
      </Container>
    </Box>
  );
}
